import React from "react";

const Vmv = () => {
  return (
    <section className="bg-light border-top section-page-height-50 d-flex justify-content-center align-items-center">
      <div className="container">
        <div className="row p-5">
          <div className="col-md-12 text-center">
            <h1 className="main-heading">Vision Mission Values</h1>
            <div className="underline mx-auto mt-3 mb-3"></div>
          </div>

          <div className="col-md-4 text-center">
            <h6>Our Vision</h6>
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Repudiandae praesentium exercitationem labore doloremque.
            </p>
          </div>
          <div className="col-md-4 text-center">
            <h6>Our Mission</h6>
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Repudiandae praesentium exercitationem labore doloremque aperiam.
            </p>
          </div>
          <div className="col-md-4 text-center">
            <h6>Our Values</h6>
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit.
              Repudiandae praesentium exercitationem labore doloremque aperiam.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vmv;
